import { QualityAssessment } from 'molstar/lib/extensions/model-archive/quality-assessment/prop';
import {
   PresetStructureRepresentations,
   StructureRepresentationPresetProvider,
} from 'molstar/lib/mol-plugin-state/builder/structure/representation-preset';
import { StateObjectRef } from 'molstar/lib/mol-state';

/**
 * Molstar preset that applies the standard `auto` representation but additionally
 * colors AlphaFold structures by pLDDT / qmean quality-assessment scores when that
 * annotation is present in the model. Non-annotated structures fall back to the
 * default auto coloring.
 *
 * `isApplicable` returns `true` only for models that carry a pLDDT or qmean
 * annotation, so Molstar only offers this preset for AlphaFold models.
 */
export const ViewerAutoPreset = StructureRepresentationPresetProvider({
   id: 'preset-structure-representation-viewer-auto',
   display: {
      name: 'Automatic (w/ Annotation)',
      group: 'Annotation',
      description:
         'Show standard automatic representation but colored by quality assessment (if available in the model).',
   },
   isApplicable(a) {
      return (
         !!a.data.models.some((m) => QualityAssessment.isApplicable(m, 'pLDDT')) ||
         !!a.data.models.some((m) => QualityAssessment.isApplicable(m, 'qmean'))
      );
   },
   params: () => StructureRepresentationPresetProvider.CommonParams,
   async apply(ref, params, plugin): Promise<StructureRepresentationPresetProvider.Result> {
      const structureCell = StateObjectRef.resolveAndCheck(plugin.state.data, ref);
      const structure = structureCell?.obj?.data;
      if (!structureCell || !structure) return {};

      const res = await PresetStructureRepresentations.auto.apply(ref, params, plugin);

      return res;
   },
});
